export const USER_TYPE = {
    INVESTOR: 'INVESTOR',
    COMPANY: 'ASSESSEE',
    PARTNER: 'PARTNER',
    LENDER: 'LENDER',
    ADMIN_TEAM: 'ADMIN_TEAM',
    LENDER_TEAM: 'LENDER_TEAM',
};

export const JOURNEY_NAME = {
    INVITE_LENDER: 'INVITE_LENDER',
    ADD_BORROWER_USER: 'ADD_BORROWER_USER',
    INVITE_TEAM_MEMBER: 'INVITE_TEAM_MEMBER',
    INVITE_PARTNER: 'INVITE_PARTNER',
};

export const ORG_MASTER_STATUS = {
    ADDITIONAL_DETAIL_COMPLETE: 'ADDITIONAL_DETAIL_COMPLETE',
    ADDITIONAL_DETAIL_PENDING: 'ADDITIONAL_USER_DETAIL_PENDING',
};
